import actionConsts from "./../../constants/actions";

const getInitPrimaryMails = mails => {
	return mails.filter(mail => mail.isPrimary);
};

const getNextMailFlag = mail => {
	return (
		mail.actionThread &&
		mail.actionThread.find(action => action.type === "next_mail")
	);
};

const getNextMail = (mail, allMails, array) => {
	let nextMailData = getNextMailFlag(mail);
	if (nextMailData) {
		let nextMail = allMails.find(mail => mail.id === nextMailData.mailId);
		if (nextMail.isPrimary) {
			return;
		}
		array.push(nextMailData.mailId);
		getNextMail(nextMail, allMails, array);
	}
};

const setMailThreads = (state, action) => {
	const { payload } = action;
	let allMails = payload.mails;
	let initMails = getInitPrimaryMails(payload.mails);

	return initMails.map(mail => {
		let array = [];
		array.push(mail.id);
		getNextMail(mail, allMails, array);
		return array;
	});
};

const mailThreads = (state = [], action = {}) => {
	switch (action.type) {
		// case actionConsts.RECEIVE_INIT_DATA:
		//     return setMailThreads(state, action)

		case actionConsts.SET_MAIL_THREADS:
			return setMailThreads(state, action);

		default:
			return state;
	}
};

export default mailThreads;



// WEBPACK FOOTER //
// /src/reducers/mailThread/index.js